import WaylineSetting from './WaylineSetting.vue'
export default WaylineSetting